import { RefObject } from "react";

import { Contract } from "@/components/Contracts/contract.interface";
import { ViewClient } from "@/components/Contracts/DisplayContractInfo/ViewClient";
import {
  CustomDrawer,
  DrawerActions,
  DrawerModules
} from "@/components/Shared/CustomDrawer";

interface ClientDrawerProps {
  isOpen: boolean;
  action: DrawerActions;
  contract: Contract;
  onClose: () => void;
  drawerContainerRef: RefObject<HTMLDivElement>;
}

export function ClientDrawer({
  isOpen,
  action,
  contract,
  onClose,
  drawerContainerRef
}: ClientDrawerProps): JSX.Element {
  return (
    <CustomDrawer
      isOpen={isOpen}
      action={action}
      module={DrawerModules.ACCOUNT}
      onCloseDrawer={onClose}
      size="medium"
      drawerContainerRef={drawerContainerRef}
    >
      {action === DrawerActions.VIEW && (
        <ViewClient
          contractInfo={contract}
          addressIdInUse={contract?.accountAddress?.id}
          contactIdInUse={contract?.accountContact?.id}
          checkingAccountIdInUse={contract?.checkingAccount?.id}
          documentIdInUse={contract?.accountDocument?.id}
          secondaryDocumentIdInUse={contract?.account?.secondaryDocument?.id}
          closeDrawer={onClose}
          drawerContainerRef={drawerContainerRef}
        />
      )}
    </CustomDrawer>
  );
}
